// Copyright (c) 2026 GUDUUOS INC. All rights reserved.
// Public discovery only: no credentials, tokens or persistent metadata cache.
let early: {server: string; at: number; promise: Promise<unknown>} | undefined;

export function warmAuthMetadata(server: string) {
    if (!server) return;
    let url: URL;
    try {url = new URL(server);} catch {return;}
    if (url.protocol !== 'https:' || url.username || url.password || url.search || url.hash) return;
    const normalized = server.replace(/\/$/, '');
    const promise = requestAuthMetadata(normalized);
    early = {server: normalized, at: Date.now(), promise};
    void promise.catch(() => {}); // boot reports failures through its existing retry UI.
}

export function consumeAuthMetadata(server: string): Promise<unknown> {
    const normalized = server.replace(/\/$/, '');
    const pending = early;
    early = undefined; // One handoff only; retries always fetch fresh metadata.
    if (pending?.server === normalized && Date.now() - pending.at < 12000 && Date.now() >= pending.at) return pending.promise;
    return requestAuthMetadata(normalized);
}

async function requestAuthMetadata(homeserver: string): Promise<unknown> {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 12000);
    try {
        const read = (path: string) => fetch(`${homeserver.replace(/\/$/, '')}${path}`, {
            signal: controller.signal, credentials: 'omit', redirect: 'error', cache: 'no-store',
        });
        let response = await read('/_matrix/client/v1/auth_metadata');
        if (response.status === 404) response = await read('/_matrix/client/unstable/org.matrix.msc2965/auth_metadata');
        if (!response.ok) throw new Error('Authentication discovery unavailable');
        return await response.json();
    } finally {
        clearTimeout(timer);
    }
}
